import React from "react";
import { strings } from "../../../strings/strings";
import { Modal, Input, Button, Textarea } from "../../../components/ui";

const AddVersionModal = ({ open, onClose, isEdit, form, errors, onChange, onSubmit, isPending }) => {
  const modalTitle = isEdit ? strings.updateAppVersion : strings.addAppVersion;
  const handleChange = (field) => (e) => {
    onChange(field)(e);
  };

  const touched = open ? {
    androidVersion: true,
    androidCode: true,
    androidLink: true,
    iosVersion: true,
    iosCode: true,
    iosLink: true,
  } : {};

  return (
    <Modal isOpen={open} onClose={onClose} title={modalTitle} size="xl">
      <div className="space-y-4">
        {isEdit && (
          <div className="mb-2 text-xs text-amber-600 leading-relaxed">
            <p>{strings.updateVersionWarning}</p>
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4 ">
            <div className="space-y-4 border border-secondary/15 rounded-lg p-3">
              <span className="pb-3 text-secondary font-semibold">{strings.android}</span>
              <Input
                label={strings.androidAppVersion}
                required
                name="androidVersion"
                value={form.androidVersion}
                onChange={handleChange("androidVersion")}
                placeholder={strings.addAndroidAppVersion}
                error={errors.androidVersion}
                touched={touched.androidVersion}
              />

              <Input
                label={strings.androidAppCode}
                required
                name="androidCode"
                value={form.androidCode}
                onChange={handleChange("androidCode")}
                placeholder={strings.addAndroidAppCode}
                error={errors.androidCode}
                touched={touched.androidCode}
              />

              <Textarea
                label={strings.androidLink}
                required
                name="androidLink"
                value={form.androidLink}
                onChange={handleChange("androidLink")}
                placeholder={strings.addAndroidLink}
                error={errors.androidLink}
                touched={touched.androidLink}
                rows={3}
                className="min-h-[80px]"
              />
            </div>

            <div className="space-y-4 border border-secondary/15 rounded-lg p-3">
              <span className="pb-3 text-secondary font-semibold">{strings.ios}</span>
              <Input
                label={strings.iosAppVersion}
                required
                name="iosVersion"
                value={form.iosVersion}
                onChange={handleChange("iosVersion")}
                placeholder={strings.addIosAppVersion}
                error={errors.iosVersion}
                touched={touched.iosVersion}
              />

              <Input
                label={strings.iosAppCode}
                required
                name="iosCode"
                value={form.iosCode}
                onChange={handleChange("iosCode")}
                placeholder={strings.addIosAppCode}
                error={errors.iosCode}
                touched={touched.iosCode}
              />

              <Textarea
                label={strings.iosLink}
                required
                name="iosLink"
                value={form.iosLink}
                onChange={handleChange("iosLink")}
                placeholder={strings.addIosLink}
                error={errors.iosLink}
                touched={touched.iosLink}
                rows={3}
                className="min-h-[80px]"
              />
            </div>
          </div>

          <div className="flex items-center justify-end gap-2 pt-4 border-t">
            <Button type="button" variant="outline" onClick={onClose}>
              {strings.cancel}
            </Button>

            <Button type="submit" variant="primary" isLoading={isPending} disabled={isPending}>
              {isPending ? strings.updating : isEdit ? strings.saveChanges : strings.saveAndAdd}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddVersionModal;
